var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"container"},[_vm._v(" Copyright © 2022 QJGAME - "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("蜀ICP备2022007434号")])])])
}]

export { render, staticRenderFns }